import { Injectable, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Collection } from '../enums/collection.enum';
import { Race } from '../models/race';
import { addDoc, deleteDoc, doc, getDoc, getDocs, getFirestore, onSnapshot, serverTimestamp, setDoc,  } from '@angular/fire/firestore';
import { Firestore, collectionData, collection, where, query, orderBy, limit } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class RaceService implements OnDestroy {

  private firestore = inject(Firestore);
  private _auth = inject(Auth);
  private _racesCollection: AngularFirestoreCollection<Race>;
  private currentUser;
  private authSubscription?;
  upcomingRes?;
  recentRes?;
  constructor(
    private _firestore: AngularFirestore,
    ) {
      this._racesCollection = this._firestore.collection<Race>(Collection.Races);
      this.authSubscription = onAuthStateChanged(this._auth, (user) => {
        if (user) {
          // User is signed in, see docs for a list of available properties
          // https://firebase.google.com/docs/reference/js/auth.user
          this.currentUser = user;
          // ...
        } else {
          // User is signed out
          this.currentUser = null;
        }
      });

      const qUpcoming = query(
        collection(this.firestore, Collection.Races),
        where('begin', '>', new Date()),
        orderBy('begin', 'asc'),
        limit(10)
      );
      this.upcomingRes = collectionData(qUpcoming);

      const qRecent = query(
        collection(this.firestore, Collection.Races),
        where('begin', '<=', new Date()),
        orderBy('begin', 'asc'),
        limit(10)
      );
      this.recentRes = collectionData(qRecent);
  }

  ngOnDestroy(): void {
    if(this.authSubscription) {
      // unsubscribes
      this.authSubscription();
    }
  }
  list(){
    return this._racesCollection.valueChanges({'idField':'id'});
  }
  upcoming(){
    return this.upcomingRes;
  }
  recent(){
      return this.recentRes;
  }
  get(id: string){
    const q = query(
      collection(this.firestore, Collection.Races),
      where('id', '==', id),
    );
    return getDocs(q);
  }
  delete(id: string){
    const docRef = doc(this.firestore, Collection.Races, id);
    return deleteDoc(docRef);
  }
  add(race: Race) {
    race.owner = this.currentUser.uid;
    race.created = serverTimestamp();
    const newRaceRef = doc(collection(this.firestore, Collection.Races));
    race.id = newRaceRef.id
    setDoc(newRaceRef, Object.assign({}, race))
    return race.id;
  }
  update(race: Race) {
    race.modified = serverTimestamp();
    race.id = race.id.trim();
    const raceRef = doc(this.firestore, Collection.Races, race.id);
    setDoc(raceRef, Object.assign({}, race), { merge: true })
  }
  // async addReferee(id, referee){
  //   const raceRef = this._racesCollection.doc(id);
  //   // Atomically add a new region to the "referees" array field.
  //   const unionRes = await raceRef.update({
  //     referees: firebase.firestore.FieldValue.arrayUnion(referee)
  //   });
  // }
  // async removeReferee(id, referee){
  //   const raceRef = this._racesCollection.doc(id);
  //   // Atomically remove a region from the "referees" array field.
  //   const unionRes = await raceRef.update({
  //     referees: firebase.firestore.FieldValue.arrayRemove(referee)
  //   });
  // }
}
